"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryOnFail = exports.isRetryParams = void 0;
function isRetryParams(params) {
    return (params === null || params === void 0 ? void 0 : params.retryMs) !== undefined || params.maxAttempts !== undefined || params.failAfterLastTimeout !== undefined;
}
exports.isRetryParams = isRetryParams;
async function retryOnFail(fn, options) {
    const { retryMs: timeoutMs, failAfterLastTimeout } = options;
    let { maxAttempts } = options;
    if (!maxAttempts) {
        const maxAttemptsDefault = 2;
        maxAttempts = (typeof timeoutMs === 'object' && timeoutMs.length) || maxAttemptsDefault;
    }
    function getTimeoutMs(iAttempt) {
        if (typeof timeoutMs === 'number') {
            return timeoutMs;
        }
        if (iAttempt >= timeoutMs.length) {
            return timeoutMs[timeoutMs.length - 1];
        }
        return timeoutMs[iAttempt];
    }
    return new Promise(async (resolve, reject) => {
        let pendingAttempts = 0;
        let done = false;
        for (let iAttempt = 0; iAttempt < maxAttempts; iAttempt++) {
            if (done) {
                return;
            }
            let timeoutId;
            let resolveTimeout;
            const timeout = new Promise((latestResolveTimeout) => {
                resolveTimeout = latestResolveTimeout;
                timeoutId = setTimeout(resolveTimeout, getTimeoutMs(iAttempt));
            });
            pendingAttempts++;
            const attempt = fn()
                .then((result) => {
                pendingAttempts--;
                if (!done) {
                    done = true;
                    resolve(result);
                }
            })
                .catch((err) => {
                pendingAttempts--;
                if (!done && pendingAttempts === 0 && iAttempt === maxAttempts - 1) {
                    done = true;
                    reject(err);
                }
            });
            await Promise.race([attempt, timeout]);
            clearTimeout(timeoutId);
            resolveTimeout();
        }
        if (!done && failAfterLastTimeout) {
            done = true;
            reject(new Error('No response received within allotted time'));
        }
    });
}
exports.retryOnFail = retryOnFail;
//# sourceMappingURL=retry-on-fail.js.map